export default {
  operacion: 'list',
}
